import { NonIdealState } from '@blueprintjs/core'
import React, { SFC } from 'react'

import { TableColumn } from './table-column.component'
import { TableRow } from './table-row.component'

type Props = {
  message: string
}

const DEFAULT_TEXT = 'No entities found...'

export const TableEmptyRow: SFC<Props> = ({ message = DEFAULT_TEXT }) => {
  return (
    <TableRow>
      <TableColumn colSpan={20}>
        <NonIdealState className="anim--fade-in" title={message} />
      </TableColumn>
    </TableRow>
  )
}



// WEBPACK FOOTER //
// ./src/app/shared/smart-table/components/table-no-rows.tsx